import React, { useState } from 'react';

export type IOptions = {
  value: string;
  label: string;
  disabled?: boolean;
}

type SelectGroupOneProps = {
  handleChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  selectedOption: string;
  options: IOptions[];
  label: string;
  name: string;
  errorText?: string;
  showError?: boolean | string;
  disabled?: boolean;
};

const SelectGroupOne: React.FC<SelectGroupOneProps> = ({
  handleChange,
  selectedOption,
  options = [],
  label,
  name,
  disabled = false,
  errorText = '',
  showError = false,
}) => {
  const [isOptionSelected, setIsOptionSelected] = useState<boolean>(false);

  const changeTextColor = () => {
    setIsOptionSelected(true);
  };

  const customOnChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    handleChange(event);
    changeTextColor();
  };

  return (
    <div className="c-select-group-one mb-4.5">
      <label className="mb-2.5 block text-black dark:text-white">{label}</label>
      <div className={`relative z-20 bg-transparent dark:bg-form-input ${disabled ? 'pointer-events-none bg-red' : ''}`}>
        <select
          name={name}
          value={selectedOption}
          onChange={customOnChange}
          className={`relative z-20 w-full appearance-none rounded border border-stroke bg-transparent px-5 py-3 outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary ${
            isOptionSelected ? 'text-black dark:text-white' : ''
          } ${
            showError
              ? 'focus:border-red dark:focus:border-red'
              : 'focus:border-primary dark:focus:border-primary'
          }`}
        >
          {options.map((option) => (
            <option
              key={option.value}
              value={option.value}
              disabled={option.disabled}
              className="text-body dark:text-bodydark"
            >
              {option.label}
            </option>
          ))}
        </select>
        <span className="absolute right-4 top-1/2 z-30 -translate-y-1/2">
          <svg
            className="fill-current"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.8">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.29289 8.29289C5.68342 7.90237 6.31658 7.90237 6.70711 8.29289L12 13.5858L17.2929 8.29289C17.6834 7.90237 18.3166 7.90237 18.7071 8.29289C19.0976 8.68342 19.0976 9.31658 18.7071 9.70711L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L5.29289 9.70711C4.90237 9.31658 4.90237 8.68342 5.29289 8.29289Z"
                fill=""
              ></path>
            </g>
          </svg>
        </span>
      </div>
      <div className="flex min-h-6 items-center justify-start">
        {showError && <p className="text-sm text-red">{errorText}</p>}
      </div>
    </div>
  );
};

export default SelectGroupOne;
